module.exports = __webpack_public_path__ + "img/148.63dd70b0.jpg";